const plans = [
    {
        name: 'Basic',
        badge: 'Save 30%',
        price: '7',
        fraction: '.99',
        description: 'Billed as $96 per year',
        features: ['25 Projects', '10 mySQL Database', '25 GB of Storage', 'Premium Support'],
        highlight: false,
    },
    {
        name: 'Agency',
        badge: 'Save 25%',
        price: '11',
        fraction: '.25',
        description: 'Billed as $135 per year',
        features: ['100 Projects', '25 mySQL Database', '80 GB of Storage', 'Premium Support'],
        highlight: false,
    },
    {
        name: 'Advanced',
        badge: 'Popular',
        price: '15',
        fraction: '.99',
        description: 'Billed as $199 per year',
        features: ['Unlimited Projects', '50 mySQL Database', '500 GB of Storage', 'VIP Support'],
        highlight: true,
    },
];

const Demo6Price = ({ isAuthenticated, onRegister, onDashboard }) => {
    const handlePlanClick = () => {
        if (isAuthenticated) {
            onDashboard();
        } else {
            onRegister();
        }
    };

    const ctaLabel = isAuthenticated ? 'Manage Plan' : 'Select Plan';

    return (
        <section id="pricing" className="bg-whitesmoke-gradient wide-60 pricing-section division">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-xl-8">
                        <div className="section-title title-01 mb-80">
                            <h2 className="h2-md">Simple And Flexible Pricing</h2>
                            <p className="p-xl">No credit card required. Change or cancel your plan anytime</p>
                        </div>
                    </div>
                </div>
                <div className="pricing-2-row pc-25">
                    <div className="row row-cols-1 row-cols-md-3">
                        {plans.map((plan) => (
                            <div className="col" key={plan.name}>
                                <div className="pricing-2-table bg-white mb-40 wow fadeInUp">
                                    <div className={`pricing-plan${plan.highlight ? ' highlight' : ''}`}>
                                        <div className="pricing-plan-title">
                                            <h5 className="h5-xs">{plan.name}</h5>
                                            <h6 className={`h6-sm ${plan.highlight ? 'bg-stateblue white-color' : 'bg-lightgrey'}`}>{plan.badge}</h6>
                                        </div>
                                        <sup className="dark-color">$</sup>
                                        <span className="dark-color">{plan.price}</span>
                                        <sup className="validity dark-color">
                                            <span>{plan.fraction}</span> / month
                                        </sup>
                                        <p className="p-md">{plan.description}</p>
                                    </div>
                                    <ul className="features">
                                        {plan.features.map((feature) => (
                                            <li key={feature}>
                                                <p className="p-md">
                                                    <span>{feature.split(' ')[0]}</span> {feature.split(' ').slice(1).join(' ')}
                                                </p>
                                            </li>
                                        ))}
                                    </ul>
                                    <button type="button" className={`btn btn-sm ${plan.highlight ? 'btn-stateblue tra-grey-hover' : 'btn-tra-grey tra-stateblue-hover'}`} onClick={handlePlanClick}>
                                        {ctaLabel}
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-10 offset-lg-1">
                        <div className="pricing-notice text-center mb-40">
                            <p className="p-md">
                                The above prices do not include applicable taxes based on your billing address. The final price will be displayed on the
                                checkout page, before the payment is completed
                            </p>
                        </div>
                    </div>
                </div>
                <div className="payment-methods pc-30">
                    <div className="row row-cols-1 row-cols-md-3">
                        <div className="col col-lg-5">
                            <div className="pbox mb-40">
                                <h6 className="h6-md">Accepted Payment Methods</h6>
                                <ul className="payment-icons ico-50">
                                    {['visa', 'am', 'discover', 'paypal', 'jcb', 'shopify'].map((icon) => (
                                        <li key={icon}>
                                            <img src={`/images/demo6/png-icons/${icon}.png`} alt="payment-icon" />
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-4">
                            <div className="pbox mb-40">
                                <h6 className="h6-md">Money Back Guarantee</h6>
                                <p>Explore OLMO Premium for 14 days. If it’s not a perfect fit, receive a full refund.</p>
                            </div>
                        </div>
                        <div className="col col-lg-3">
                            <div className="pbox mb-40">
                                <h6 className="h6-md">SSL Encrypted Payment</h6>
                                <p>Your information is protected by 256-bit SSL encryption.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Demo6Price;
